import React, { useState } from 'react';
import { X, CreditCard, Wallet, ExternalLink, Check, Shield, Lock } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../contexts/LanguageContext';

const REVOLUT_LINK = "https://revolut.me/estheri5im";

// Payment method icons
const PaymentMethodIcon = ({ type }) => {
  const icons = {
    visa: (
      <svg viewBox="0 0 48 32" className="h-8 w-auto">
        <rect fill="#1A1F71" width="48" height="32" rx="4"/>
        <path fill="#FFFFFF" d="M19.5 21.5h-3l1.9-11h3l-1.9 11zm-5.7 0h-3l-2.3-8.5c-.1-.4-.3-.7-.7-.8-.6-.3-1.3-.5-2.1-.7l.1-.5h4.8c.6 0 1.2.4 1.3 1l1.2 6.4 2.9-7.4h3l-4.2 10.5zm17.4-7.4c0-.6.5-1.2 1.6-1.4.5-.1 2.1-.2 3.8.7l.7-3.1c-.9-.3-2.1-.7-3.6-.7-3.8 0-6.5 2-6.5 4.9 0 2.1 1.9 3.3 3.4 4 1.5.8 2 1.3 2 2 0 1.1-1.2 1.5-2.3 1.6-1.9 0-3-.5-3.9-.9l-.7 3.2c.9.4 2.5.7 4.2.7 4 0 6.7-2 6.7-5-.1-3.8-5.4-4-5.4-5.8zm13.3 7.4h2.6l-2.3-11h-2.4c-.5 0-1 .3-1.2.8l-4.2 10.2h2.9l.6-1.6h3.6l.4 1.6zm-3.1-3.9l1.5-4.1.8 4.1h-2.3z"/>
      </svg>
    ),
    mastercard: (
      <svg viewBox="0 0 48 32" className="h-8 w-auto">
        <rect fill="#000000" width="48" height="32" rx="4"/>
        <circle fill="#EB001B" cx="18" cy="16" r="8"/>
        <circle fill="#F79E1B" cx="30" cy="16" r="8"/>
        <path fill="#FF5F00" d="M24 10.5c-1.9 1.5-3 3.4-3 5.5s1.1 4 3 5.5c1.9-1.5 3-3.4 3-5.5s-1.1-4-3-5.5z"/>
      </svg>
    ),
    paypal: (
      <svg viewBox="0 0 48 32" className="h-8 w-auto">
        <rect fill="#003087" width="48" height="32" rx="4"/>
        <path fill="#FFFFFF" d="M18.7 8h5.5c2.7 0 4.6 1.3 4.3 4.3-.4 3.5-2.5 5.4-5.7 5.4h-1.5c-.4 0-.8.3-.9.7l-.8 4.9c0 .2-.2.4-.4.4h-2.6c-.3 0-.5-.3-.4-.6l2.1-14.5c.1-.4.4-.6.8-.6h-.4zm6.3 4.3c.1-.8-.5-1.3-1.4-1.3h-1.1c-.2 0-.4.1-.4.3l-.5 3.2c0 .1.1.2.2.2h.9c1.4 0 2.1-.9 2.3-2.4z"/>
        <path fill="#009CDE" d="M32.5 8h5.5c2.7 0 4.6 1.3 4.3 4.3-.4 3.5-2.5 5.4-5.7 5.4h-1.5c-.4 0-.8.3-.9.7l-.8 4.9c0 .2-.2.4-.4.4h-2.6c-.3 0-.5-.3-.4-.6l2.1-14.5c.1-.4.4-.6.8-.6h-.4zm6.3 4.3c.1-.8-.5-1.3-1.4-1.3h-1.1c-.2 0-.4.1-.4.3l-.5 3.2c0 .1.1.2.2.2h.9c1.4 0 2.1-.9 2.3-2.4z"/>
      </svg>
    ),
    revolut: (
      <svg viewBox="0 0 48 32" className="h-8 w-auto">
        <rect fill="#191C1F" width="48" height="32" rx="4"/>
        <path fill="#FFFFFF" d="M12 12h4.8c2.4 0 3.9 1.4 3.9 3.5 0 1.5-.8 2.7-2.1 3.2l2.5 3.8h-2.8l-2.2-3.5h-1.5v3.5H12V12zm2.6 5h1.8c1.1 0 1.7-.6 1.7-1.5s-.6-1.5-1.7-1.5h-1.8v3z"/>
        <circle fill="#FFFFFF" cx="32" cy="16" r="6"/>
        <path fill="#191C1F" d="M32 13l2 3h-4l2-3zm0 6l-2-3h4l-2 3z"/>
      </svg>
    ),
    gpay: (
      <svg viewBox="0 0 48 32" className="h-8 w-auto">
        <rect fill="#FFFFFF" width="48" height="32" rx="4" stroke="#E0E0E0"/>
        <path fill="#4285F4" d="M23.5 16.5v3h-1.5v-7.5h4c1 0 1.9.4 2.5 1 .7.7 1 1.5 1 2.3s-.3 1.6-1 2.2c-.6.6-1.4 1-2.5 1h-2.5zm0-3.3v2.2h2.6c.5 0 1-.2 1.3-.5.4-.3.5-.7.5-1.1s-.2-.8-.5-1.1c-.3-.3-.8-.5-1.3-.5h-2.6z"/>
        <path fill="#34A853" d="M33.8 13.2c1.2 0 2.1.3 2.8 1 .7.7 1 1.6 1 2.8v4h-1.4v-.9c-.5.8-1.3 1.1-2.3 1.1-.8 0-1.5-.2-2-.7s-.8-1-.8-1.7c0-.7.3-1.3.8-1.7s1.3-.6 2.3-.6c.8 0 1.4.2 1.9.5v-.4c0-.5-.2-1-.6-1.3-.4-.3-.9-.5-1.5-.5-.9 0-1.6.4-2 1l-1.1-.8c.7-1 1.7-1.5 3-1.5zm-.3 6.6c.5 0 1-.2 1.4-.5.4-.3.6-.7.6-1.1v-.5c-.4-.3-1-.5-1.6-.5s-1.1.1-1.5.4c-.3.3-.5.6-.5 1s.2.7.5 1c.4.2.8.3 1.2.3z"/>
        <path fill="#FBBC04" d="M15 16c0-2.2 1.8-4 4-4s4 1.8 4 4-1.8 4-4 4-4-1.8-4-4zm1.5 0c0 1.4 1.1 2.5 2.5 2.5s2.5-1.1 2.5-2.5-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5z"/>
        <path fill="#EA4335" d="M11 12h1.5v8H11z"/>
      </svg>
    ),
  };
  return icons[type] || null;
};

const translations = {
  en: {
    title: 'Complete Your Payment',
    subtitle: 'Secure payment for your booking',
    serviceName: 'Service',
    amount: 'Amount to pay',
    payNow: 'Pay Now',
    payLater: 'Pay at the salon',
    securePayment: 'Secure Payment',
    secureInfo: 'Your payment is processed securely via Revolut',
    acceptedMethods: 'Accepted payment methods',
    redirectInfo: 'You will be redirected to Revolut to complete your payment',
    thankYou: 'Thank you!',
    paymentChoice: 'Choose your payment option',
    payOnline: 'Pay Online Now',
    payOnlineDesc: 'Quick and secure payment via Revolut',
    payAtSalon: 'Pay at Salon',
    payAtSalonDesc: 'Pay when you arrive for your appointment',
  },
  fr: {
    title: 'Finaliser Votre Paiement',
    subtitle: 'Paiement sécurisé pour votre réservation',
    serviceName: 'Service',
    amount: 'Montant à payer',
    payNow: 'Payer Maintenant',
    payLater: 'Payer au salon',
    securePayment: 'Paiement Sécurisé',
    secureInfo: 'Votre paiement est traité de manière sécurisée via Revolut',
    acceptedMethods: 'Méthodes de paiement acceptées',
    redirectInfo: 'Vous serez redirigé vers Revolut pour finaliser votre paiement',
    thankYou: 'Merci !',
    paymentChoice: 'Choisissez votre option de paiement',
    payOnline: 'Payer en Ligne',
    payOnlineDesc: 'Paiement rapide et sécurisé via Revolut',
    payAtSalon: 'Payer au Salon',
    payAtSalonDesc: 'Payez à votre arrivée pour votre rendez-vous',
  },
  pt: {
    title: 'Completar o Pagamento',
    subtitle: 'Pagamento seguro para a sua reserva',
    serviceName: 'Serviço',
    amount: 'Valor a pagar',
    payNow: 'Pagar Agora',
    payLater: 'Pagar no salão',
    securePayment: 'Pagamento Seguro',
    secureInfo: 'O seu pagamento é processado de forma segura via Revolut',
    acceptedMethods: 'Métodos de pagamento aceites',
    redirectInfo: 'Será redirecionado para o Revolut para completar o pagamento',
    thankYou: 'Obrigado!',
    paymentChoice: 'Escolha a sua opção de pagamento',
    payOnline: 'Pagar Online',
    payOnlineDesc: 'Pagamento rápido e seguro via Revolut',
    payAtSalon: 'Pagar no Salão',
    payAtSalonDesc: 'Pague quando chegar para a sua consulta',
  },
  de: {
    title: 'Zahlung Abschließen',
    subtitle: 'Sichere Zahlung für Ihre Buchung',
    serviceName: 'Service',
    amount: 'Zu zahlender Betrag',
    payNow: 'Jetzt Bezahlen',
    payLater: 'Im Salon bezahlen',
    securePayment: 'Sichere Zahlung',
    secureInfo: 'Ihre Zahlung wird sicher über Revolut verarbeitet',
    acceptedMethods: 'Akzeptierte Zahlungsmethoden',
    redirectInfo: 'Sie werden zu Revolut weitergeleitet, um Ihre Zahlung abzuschließen',
    thankYou: 'Danke!',
    paymentChoice: 'Wählen Sie Ihre Zahlungsoption',
    payOnline: 'Online Bezahlen',
    payOnlineDesc: 'Schnelle und sichere Zahlung über Revolut',
    payAtSalon: 'Im Salon Bezahlen',
    payAtSalonDesc: 'Bezahlen Sie bei Ihrem Termin',
  },
  es: {
    title: 'Completar Su Pago',
    subtitle: 'Pago seguro para su reserva',
    serviceName: 'Servicio',
    amount: 'Importe a pagar',
    payNow: 'Pagar Ahora',
    payLater: 'Pagar en el salón',
    securePayment: 'Pago Seguro',
    secureInfo: 'Su pago se procesa de forma segura a través de Revolut',
    acceptedMethods: 'Métodos de pago aceptados',
    redirectInfo: 'Será redirigido a Revolut para completar su pago',
    thankYou: '¡Gracias!',
    paymentChoice: 'Elija su opción de pago',
    payOnline: 'Pagar en Línea',
    payOnlineDesc: 'Pago rápido y seguro a través de Revolut',
    payAtSalon: 'Pagar en el Salón',
    payAtSalonDesc: 'Pague cuando llegue a su cita',
  },
};

// Extract numeric price from price string like "€50" or "50€" or "From €80"
const extractPrice = (priceStr) => {
  if (!priceStr) return null;
  const match = priceStr.match(/(\d+)/);
  return match ? parseInt(match[1], 10) : null;
};

const PaymentModal = ({ isOpen, onClose, booking, onPaymentComplete }) => {
  const { language } = useLanguage();
  const t = translations[language] || translations.en;
  const [paymentChoice, setPaymentChoice] = useState(null);

  if (!isOpen || !booking) return null;

  const price = extractPrice(booking.service_price);
  
  // Build Revolut payment URL with amount
  const getRevolutPaymentUrl = () => {
    if (price) {
      return `${REVOLUT_LINK}?amount=${price}&currency=EUR`;
    }
    return REVOLUT_LINK;
  };

  const handlePayNow = () => {
    // Open Revolut payment link in new tab
    window.open(getRevolutPaymentUrl(), '_blank');
    // Mark as payment initiated
    if (onPaymentComplete) {
      onPaymentComplete('online');
    }
    onClose();
  };

  const handlePayLater = () => {
    if (onPaymentComplete) {
      onPaymentComplete('salon');
    }
    onClose();
  };

  return (
    <div 
      className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-2xl max-w-md w-full max-h-[90vh] overflow-y-auto shadow-2xl"
        onClick={(e) => e.stopPropagation()}
        data-testid="payment-modal"
      >
        {/* Header */}
        <div className="bg-gradient-to-r from-kamit-brown to-kamit-dark p-6 rounded-t-2xl">
          <button 
            onClick={onClose}
            className="absolute top-4 right-4 text-kamit-beige/80 hover:text-kamit-beige transition-colors"
          >
            <X className="h-6 w-6" />
          </button>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 bg-kamit-gold/20 rounded-full flex items-center justify-center">
              <CreditCard className="h-6 w-6 text-kamit-gold" />
            </div>
            <div>
              <h2 className="font-heading text-xl text-kamit-beige">
                {t.title}
              </h2>
              <p className="text-kamit-beige/70 text-sm">
                {t.subtitle}
              </p>
            </div>
          </div>
        </div>

        <div className="p-6">
          {/* Booking Summary */}
          <div className="bg-kamit-cream rounded-xl p-4 mb-6">
            <div className="flex justify-between items-center mb-2">
              <span className="text-kamit-brown/70 text-sm">{t.serviceName}</span>
              <span className="text-kamit-brown font-medium">{booking.service_name}</span>
            </div>
            <div className="flex justify-between items-center pt-2 border-t border-kamit-brown/10">
              <span className="text-kamit-brown font-medium">{t.amount}</span>
              <span className="text-kamit-gold font-bold text-xl">{booking.service_price}</span>
            </div>
          </div>

          {/* Payment Methods */}
          <div className="mb-6">
            <p className="text-kamit-brown/70 text-sm mb-3">{t.acceptedMethods}</p>
            <div className="flex flex-wrap gap-3 justify-center">
              <PaymentMethodIcon type="visa" />
              <PaymentMethodIcon type="mastercard" />
              <PaymentMethodIcon type="paypal" />
              <PaymentMethodIcon type="revolut" />
              <PaymentMethodIcon type="gpay" />
            </div>
          </div>

          {/* Payment Options */}
          <div className="space-y-3 mb-6">
            <p className="text-kamit-brown font-medium text-center mb-4">{t.paymentChoice}</p>
            
            {/* Pay Online */}
            <button
              onClick={handlePayNow}
              className="w-full p-4 border-2 border-kamit-gold bg-kamit-gold/5 rounded-xl hover:bg-kamit-gold/10 transition-all group text-left"
              data-testid="pay-online-btn"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-kamit-gold rounded-full flex items-center justify-center group-hover:scale-110 transition-transform">
                  <Wallet className="h-6 w-6 text-kamit-dark" />
                </div>
                <div className="flex-1">
                  <p className="font-medium text-kamit-brown">{t.payOnline}</p>
                  <p className="text-sm text-kamit-brown/60">{t.payOnlineDesc}</p>
                </div>
                <ExternalLink className="h-5 w-5 text-kamit-gold" />
              </div>
            </button>

            {/* Pay at Salon */}
            <button
              onClick={handlePayLater}
              className="w-full p-4 border-2 border-kamit-brown/20 rounded-xl hover:border-kamit-brown/40 hover:bg-kamit-brown/5 transition-all group text-left"
              data-testid="pay-later-btn"
            >
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-kamit-brown/10 rounded-full flex items-center justify-center group-hover:bg-kamit-brown/20 transition-colors">
                  <CreditCard className="h-6 w-6 text-kamit-brown" />
                </div>
                <div className="flex-1">
                  <p className="font-medium text-kamit-brown">{t.payAtSalon}</p>
                  <p className="text-sm text-kamit-brown/60">{t.payAtSalonDesc}</p>
                </div>
              </div>
            </button>
          </div>

          {/* Security Info */}
          <div className="flex items-center gap-2 justify-center text-kamit-brown/50 text-xs">
            <Lock className="h-4 w-4" />
            <span>{t.secureInfo}</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentModal;
